import getImageSrcSetSizes from 'Shared/getImageSrcSetSizes';
const bg_config = {
  original: 1920,
  desktop: 1920,
  available: [1280, 1920, 2560, 4096]
};
const bg_src = '/images/home/2024-06/mywo_home.jpg';
const [bg_srcset, bg_sizes] = getImageSrcSetSizes(bg_src, bg_config);
export default function HomeBanner({
  ...props
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: "c-front-page-intro__bg",
    src: bg_src,
    srcSet: bg_srcset,
    sizes: bg_sizes
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__filter"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "c-front-page-intro__title"
  }, "L'espace de travail", ' ', /*#__PURE__*/React.createElement("br", null), "qui vous ressemble."));
}
